// Footer.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaArrowUp,
} from "react-icons/fa";
import ReactCountryFlag from "react-country-flag";
import { FaXTwitter } from "react-icons/fa6";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubscribe = () => {
    if (email) {
      setIsSubscribed(true);
      setEmail("");
      setTimeout(() => setIsSubscribed(false), 3000);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const brandStyles = {
    primaryGreen: '#91C949',
    deepBlue: '#394C92',
    linkHover: '#68A637', // Slightly darker green for hover effect
    lightBg: '#F0F5EB', // A very light, green-tinted background
};

  return (
    <footer style={{backgroundColor: brandStyles.deepBlue}} className="text-white pt-5 pb-3 border-top fs-6">
      <div className="container">
        <div className="row gy-4">
           <h3 className="fw-bold mb-3 fs-3" style={{ color: brandStyles.primaryGreen }}>🌿 Orgavitaz</h3>     
          {/* Orgavitaz Info */}
          <div className="col-md-4">
              <p className="mb-2">
              <strong style={{ color: brandStyles.primaryGreen }}>Registered address:</strong><br />
              Sristi Bio-Sciences Private Limited <br />
               11-9-49, Suite 301, 3rd Floor, Ace Prime Krishna Ventures Road No: 1, Laxmi Nagar Colony, Kothapet, Hyderabad-500035 Telangana, India
            </p>
            <p className="mb-2">
              Sristi ANI <br />
              Second Floor, 72 D, Kanchana Enclave, 7th Cross Thillai Nagar, Tiruchirappalli-620018<br />
              Tamil Nadu, India
              </p>

             <p className="mb-2">
              <strong style={{ color: brandStyles.primaryGreen }}>Discovery R&D Address:</strong><br />
              Sristi Bio-Sciences Private Limited. <br />No 468, 1st Floor, CPC corporate Hub, Thadagam Road RS Puram West Coimbatore-641002, Tamil Nadu, India
            </p>
             <p className="mb-2">
              <strong style={{ color: brandStyles.primaryGreen }}>Primary Processing Center:</strong><br />
              Sristi Bio-Sciences Private Limited <br />
              PPC, Arasalur, Thottiyam, Tiruchirappalli-621203 <br />
              Tamil Nadu , India
            </p>
          
          </div>

         

          {/* International Offices */}
          <div className="col-md-3">
             <p className="mb-2">
              <strong style={{ color: brandStyles.primaryGreen }}>Manufacturing 1:</strong><br />
              Plot No.:12, TSIIC Biotech Park–-3 Genome Valley, Karkapatla(V), <br />
              Markook(M) Hyderabad-502281 <br />
              Telangana, India
            </p>
            <p className="mb-0">
              <strong style={{ color: brandStyles.primaryGreen }}>Manufacturing 2:</strong><br />
              154/4, Siluvaigiri Road, Sendarapatti PO, Gangavalli TK, Salem-636110 <br />
              Tamilnadu, India
            </p>
            <br/>
            <h6 className="fw-bold mb-3 fs-5" style={{ color: brandStyles.primaryGreen }}>Business Partners</h6>
            <ul className="list-unstyled">
              <li className="mt-2"style={{ color: brandStyles.primaryGreen }}><ReactCountryFlag
                countryCode="CA"
                svg
                style={{
                  width: "1.5em",
                  height: "1em",
                  verticalAlign: "-0.1em",
                  marginRight: "0.4em"
                }}/> 
              <strong>RNP Nutrition INC, Canada</strong><br /><span className="text-white">75, Rue Queen, Suite 1400 Montreal, Quebec, H3C2N6</span></li>
              <li style={{ color: brandStyles.primaryGreen }}>
                <ReactCountryFlag
                  countryCode="US"
                  svg
                  style={{
                    width: "1.5em",
                    height: "1em",
                    verticalAlign: "-0.1em",
                    marginRight: "0.4em"
                  }}
                />
                 <strong>RNP Nutrition INC, USA</strong><br /><span className="text-white">16809, South Central Avenue <br /> Carson, CA, 90746, USA</span></li>
            </ul>

          
          </div>

           {/* Quick Links */}
          <div className="col-md-2">
            <h6 className="fw-bold mb-3 fs-5" style={{ color: brandStyles.primaryGreen }}>Quick Links</h6>
            <ul className="list-unstyled">
              <li><Link to="/" className="text-white text-decoration-none">▶  Home</Link></li>
              <li><Link to="/about" className="text-white text-decoration-none">▶  About</Link></li>
              <li><Link to="/Portfolio" className="text-white text-decoration-none">▶  Portfolio</Link></li>
              <li><a href="/Services" className="text-white text-decoration-none">▶  Services</a></li>
              <li><Link to="/contact" className="text-white text-decoration-none">▶  Contact</Link></li>
            </ul>
            <ul className="list-unstyled"style={{marginTop: '8rem'}}>
              <li style={{ color: brandStyles.primaryGreen }}>
                <ReactCountryFlag
                countryCode="FR"
                svg
                style={{
                  width: "1.5em",
                  height: "1em",
                  marginRight: "0.5em",
                  verticalAlign: "-0.1em"
                }}
              />
                <strong>RNP Nutrition INC, France</strong><br /><span className="text-white">Sristi ANI <br /> 566, Rue Du Perthuis <br /> Herouville St. Clair <br /> 14200, France</span></li>
              
            </ul>
          </div>

          {/* Contact + Newsletter */}
          <div className="col-md-3">
            <h6 className="fw-bold mb-3 fs-5" style={{ color: brandStyles.primaryGreen }}>Get In Touch</h6>
            <p className="mb-1"><strong>Email:</strong> contactus@orgavitaz.com</p>
            <p className="mb-1"><strong>Phone:</strong> +91-40-24045551</p>
            <p className="mb-3"><strong>Location:</strong> Hyderabad, India</p>

            {/* Newsletter */}
            <h6 className="mt-4 fw-bold mb-2 fs-5" style={{ color: brandStyles.primaryGreen }}>📬 Stay Updated</h6>
            <div className="input-group mb-2">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-control"
                placeholder="Enter your email" required
              />
              <button className="btn btn-success" onClick={handleSubscribe}>
                Subscribe
              </button>
            </div>
            {isSubscribed && (
              <div style={{ color: brandStyles.primaryGreen }}>✅ Thank you for subscribing!</div>
            )}

            {/* Social Icons */}
            <div className="d-flex gap-4 mt-4 fs-5">
              <a href="#" className="text-white"><FaFacebookF /></a>
              <a href="#" className="text-white"><FaXTwitter /></a>
              <a href="#" className="text-white"><FaInstagram /></a>
              <a href="#" className="text-white"><FaLinkedinIn /></a>
            </div>
          </div>
        </div>

        <hr className="border-white my-4" />

        {/* Bottom Row */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
         

          {/* Copyright */}
          <p className="mb-0 text-white text-center flex-grow-1 fs-6">
            © 2025 Orgavitaz. All rights reserved. |{" "}
            <a href="#" style={{ color: brandStyles.primaryGreen }} className="text-decoration-none">Privacy</a> |{" "}
            <a href="#" style={{ color: brandStyles.primaryGreen }} className="text-decoration-none">Terms</a> |{" "}
            <a href="#" style={{ color: brandStyles.primaryGreen }} className="text-decoration-none">Cookies</a>
          </p>

          {/* Back to Top - right corner */}
          <button
            onClick={scrollToTop}
            // 🚀 FIX 15: Used custom green for outline button
            style={{ 
                borderColor: brandStyles.primaryGreen, 
                color: brandStyles.primaryGreen, 
                width: "45px", 
                height: "45px" 
            }}
            className="btn rounded-circle ms-md-3 mt-3 mt-md-0"
            title="Back to top"
          >
            <FaArrowUp />
          </button>
        </div>
      </div>
    </footer>
  );
}
